import React from 'react';
import Title from 'lib/src/components/typography/Title';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import { challengesBreadcrumb } from '../../constants/breadcrumbItems';
import ChallengesTable from '../challenges/ChallengesTable';
import CreateHeader from '@components/layout/createHeader/CreateHeader';

const Challenges: React.FC = () => {
    return (
        <>
            <Breadcrumb items={challengesBreadcrumb} />
            <CreateHeader>
                <Title>Challenges</Title>
            </CreateHeader>
            <ChallengesTable />
        </>
    );
};

export default Challenges;
